module.exports = KalturaPlayer;